import {
  createClient,
  // getCustomConfig,
  HttpError,
} from "@/http/lib";
import { systemErrorResponseHandler } from "../handlers/responseError";
import { apiBaseUrl } from "../config";
import { responseHandler } from "../handlers";

export const basicApi = createClient({
  timeout: 40000,
  baseURL: apiBaseUrl,
});

basicApi.interceptors.request.use(
  (config) => {
    // const customConfig = getCustomConfig(config);
    const app = basicApi.getVueInstance();
    const store = app.config.globalProperties.$store;
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = store.getters["user/token"];
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(new HttpError(error));
  }
);

basicApi.interceptors.response.use(
  (response) => {
    const app = basicApi.getVueInstance();
    const store = app.config.globalProperties.$store;
    store.dispatch("touch/setTouchTimer");
    return responseHandler(response, basicApi.getVueInstance());
  },
  (error) => {
    systemErrorResponseHandler(error, basicApi.getVueInstance());
    if (error instanceof HttpError && !error.isCancel())
      return Promise.reject(new HttpError(error));
  }
);
